import Button from '../../Button/Button';
import MonthSelectorHeader from './MonthSelectorHeader';
type MonthSelectorProps = {
    onMonthSelection: (month: number) => void;
    onYearChange: (year: number) => void;
    year: number;
};
export default function MonthSelector({
    year,
    onMonthSelection,
    onYearChange,
}: MonthSelectorProps) {
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    const handleMonthSelection = (month: string) => {
        onMonthSelection(monthNames.indexOf(month));
    };

    return (
        <>
            <MonthSelectorHeader onYearChange={onYearChange} year={year} />
            <div className="alli-mt-6 alli-grid alli-w-full alli-grid-cols-3 alli-gap-6 alli-text-center alli-text-sm alli-text-blue-gray-700 ">
                {monthNames.map((month, idx) => (
                    <Button
                        onClick={() => handleMonthSelection(month)}
                        variant="text-secondary"
                        key={idx}
                        type="button"
                        className="alli-justify-center">
                        {month.substring(0, 3)}
                    </Button>
                ))}
            </div>
        </>
    );
}
